// @flow

export default class Spaces {
  terrace: boolean;
  balcony: boolean;
  garden: boolean;
  roof: boolean;
  
  constructor(data: any = {}) {
    this.terrace = data.terrace;
    this.balcony = data.balcony;
    this.garden = data.garden;
    this.roof = data.roof;
  }
}
